/*
 * @Author: cc
 * @Date: 2020-01-09 13:22:08
 * @LastEditTime: 2021-03-25 11:14:16
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\networkResource\networkResourceRouter.js
 * @Description:网络资源模块路由
 */

'use strict';
angular.module('networkSourceCenterRouterModule', []).config([
    '$stateProvider',
    '$urlRouterProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource', {
                url: '/networksource',
                views: {
                    main: {
                        templateUrl: './networkResource/newNetworkResourceMain.html'
                    },
                    'left@front.networksource': {
                        templateUrl: './networkResource/left/left_tpl.html',
                        controller: 'networkSourceCenteLeftCtrl',
                    },
                },
            })
            .state('front.networksource.myresources', {
                // 我的资源
                url: '/myresources',
                views: {
                    'main@front.networksource': {
                        template: '<div ui-view="main"></div>',
                    },
                },
            })
            .state('front.networksource.featuredresource', {
                // 特色资源集合
                url: '/featuredresource',
                views: {
                    'main@front.networksource': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('front.networksource.classifiedresource', {
                // 分类资源集合
                url: '/classifiedresource',
                views: {
                    'main@front.networksource': {
                        template: "<div ui-view='main'></div>",
                    },
                },
            })
            .state('front.networksource.hotKey', {
                url: '/eventcorrelation?hotKey',
                views: {
                    'body@networksource': {
                        templateUrl: './planningCenter/cueSelectedTopic/cueMonitoring/more/cueMonitorMore_tpl.html',
                        controller: 'planCenterEventCorrelationHotKeyCtrl',
                    },
                },
            })
            .state('digitaldetailjtcpg', {
                url: '/digitaldetailjtcpg?nodeid&bc&docpubtime&serviceid&papername',
                views: {
                    '': {
                        templateUrl: './networkResource/classifiedResource/digitalnews/detail/detail_tpl.html',
                        controller: 'resCenDigitalPreviewDetailCtrl',
                    },
                },
            })
            .state('digitaldetailother', {
                url: '/digitaldetailother?nodeid&bc&docpubtime&serviceid&papername&qjnews&historystore',
                views: {
                    '': {
                        templateUrl: './networkResource/classifiedResource/digitalnews/detail/digitalDetail_tpl.html',
                        controller: 'resCenDigitalPreviewOtherDetailCtrl',
                    },
                },
            });
    },
]);
